import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import FinalCta from "@/pages/home/components/FinalCta";
import HostingPlans from "@/pages/hospedagem/components/HostingPlans";
import IncludedFeatures from "@/pages/hospedagem/components/IncludedFeatures";
import PlanComparison from "@/pages/hospedagem/components/PlanComparison";
import MigrationSteps from "@/pages/hospedagem/components/MigrationSteps";
import HostingFaq from "@/pages/hospedagem/components/HostingFaq";
import SolucoesCrossLink from "@/components/feature/SolucoesCrossLink";
import { detailedPlans, hostingFaqs } from "@/mocks/hospedagem";
import { PLAN_IMAGE_HOSTING } from "@/constants/site";

export default function Hospedagem() {
  return (
    <SiteLayout>
      <Seo
        title="Hospedagem de Sites para Empresas | Planos a partir de R$ 50 | NXHOST"
        description="Planos de hospedagem de sites com e-mail profissional, certificado SSL, backups e suporte especializado. Profissional, Empresarial, Premium e Semi Dedicada a partir de R$ 50/mês."
        keywords="hospedagem de sites, hospedagem profissional, hospedagem para empresas, planos de hospedagem, hospedagem com e-mail profissional, hospedagem de sites Brasil"
        path="/hospedagem"
        titleEn="Website Hosting for Business | Plans from R$50 | NXHOST"
        titleEs="Hosting Web para Empresas | Planes desde R$50 | NXHOST"
        descriptionEn="Website hosting plans with professional email, SSL certificate, backups and specialized support. Professional, Business, Premium and Semi-Dedicated from R$50/month."
        descriptionEs="Planes de hosting web con correo profesional, certificado SSL, copias de seguridad y soporte especializado. Professional, Empresarial, Premium y Semi Dedicado desde R$50/mes."
        breadcrumbs={[
          { name: "Início", path: "/" },
          { name: "Hospedagem", path: "/hospedagem" },
        ]}
        plans={detailedPlans.map((plan) => ({
          name: plan.name,
          price: plan.price,
          url: plan.url,
          description: plan.summary,
          image: PLAN_IMAGE_HOSTING,
          category: "Hospedagem de sites",
        }))}
        faqs={hostingFaqs}
      />
      <PageHero
        badge="Hospedagem de sites"
        badgeIcon="ri-server-line"
        title="Hospedagem preparada para o próximo passo do seu negócio."
        subtitle="Escolha a estrutura de acordo com o momento e a necessidade do seu projeto. Aqui você encontra infraestrutura profissional, e-mail no domínio da empresa e suporte especializado."
        crumbs={[{ label: "Início", to: "/" }, { label: "Hospedagem" }]}
      >
        <Reveal delay={220}>
          <div className="rounded-2xl border border-background-50/10 bg-foreground-900/60 p-5 backdrop-blur-sm">
            <div className="flex items-center justify-between">
              <span className="text-xs uppercase tracking-wide text-background-400">
                Painel NXHOST
              </span>
              <span className="flex items-center gap-1.5 text-[11px] font-medium text-secondary-400">
                <span className="h-2 w-2 rounded-full bg-secondary-400"></span>
                Online
              </span>
            </div>
            <div className="mt-4 flex items-end gap-1">
              <span className="text-sm text-background-400">a partir de</span>
            </div>
            <div className="mt-1 flex items-end gap-1">
              <span className="text-sm font-medium text-background-300">R$</span>
              <span className="font-heading text-5xl font-bold text-background-50">50</span>
              <span className="mb-2 text-sm text-background-300">/mês</span>
            </div>
            <div className="mt-5 space-y-3">
              <div>
                <div className="mb-1.5 flex items-center justify-between text-[11px] text-background-400">
                  <span>Recursos</span>
                  <span>Configurável</span>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-50/10">
                  <div className="h-full w-[70%] rounded-full bg-gradient-to-r from-primary-500 to-accent-400"></div>
                </div>
              </div>
              <div>
                <div className="mb-1.5 flex items-center justify-between text-[11px] text-background-400">
                  <span>Disponibilidade</span>
                  <span>Alta</span>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-50/10">
                  <div className="h-full w-[92%] rounded-full bg-gradient-to-r from-secondary-500 to-accent-400"></div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </PageHero>

      <HostingPlans />
      <IncludedFeatures />
      <PlanComparison />
      <MigrationSteps />
      <HostingFaq />

      <SolucoesCrossLink
        title="Precisa de mais do que hospedagem?"
        description="Além da hospedagem, a NXHOST cria sites, lojas virtuais e estruturas digitais completas, com SEO, marketing digital e anúncios no Google para a sua empresa crescer na internet."
        links={[
          { label: "Criação de Sites", to: "/sites" },
          { label: "Loja Virtual", to: "/lojas-virtuais" },
          { label: "SEO", to: "/solucoes#seo" },
          { label: "Google Ads", to: "/solucoes#googleads" },
        ]}
      />

      <FinalCta />
    </SiteLayout>
  );
}